// Dono de cada produto no carrinho do garçom (dono, 24/09/2026). O produto
// lançado para uma pessoa aparece na comanda DELA ("lançado pelo garçom"),
// entra na conta dela e segue o cashback do módulo Mesas. Sem dono = da mesa.
// O último dono escolhido vira o padrão dos próximos produtos (o garçom anota
// o pedido de uma pessoa de cada vez).
import { useCallback, useEffect, useState } from "react";

import { usePessoasMesa } from "./usePessoasMesa";

export function useDonosCarrinho(mesa, ativo, setCart) {
  const { pessoas, donos, aberta, qrLigado, criar } = usePessoasMesa(mesa, ativo);
  const [padrao, setPadrao] = useState(null); // {id, nome}
  const [novaPara, setNovaPara] = useState(null); // cartItemId que pediu "+ Nova pessoa"
  const mesaId = mesa?.id;

  useEffect(() => { setPadrao(null); }, [mesaId]);

  // Mesa aberta numa loja com Mesa QR (ou que já tem gente na mesa)
  const ligado = aberta && (qrLigado || pessoas.length > 0);

  const marcar = useCallback((item) => (
    padrao ? { ...item, _cliente_id: padrao.id, _cliente_nome: padrao.nome } : item
  ), [padrao]);

  const mesmoDono = (a, b) => (a._cliente_id || null) === (b._cliente_id || null);

  const escolher = useCallback((cartItemId, id, nome) => {
    setPadrao(id ? { id, nome } : null);
    setCart((prev) => prev.map((i) => ((i.cartItemId || i.id) === cartItemId
      ? { ...i, _cliente_id: id || undefined, _cliente_nome: nome || undefined }
      : i)));
  }, [setCart]);

  const criarPessoa = useCallback(async (nome, cpf) => {
    const p = await criar(nome, cpf);
    const alvo = novaPara;
    setNovaPara(null);
    if (p?.cliente_id && alvo != null) escolher(alvo, p.cliente_id, p.primeiro_nome || p.nome);
  }, [criar, novaPara, escolher]);

  // Campos que vão junto no envio: na mesa (comanda/conta) e no pedido
  const carimbar = useCallback((item, envio) => ({
    ...item,
    _origem: "garcom",
    _envio: envio,
    _por: item._cliente_nome || undefined,
  }), []);
  const noPedido = (item) => ({
    cliente_id: item._cliente_id || null,
    cliente_nome: item._cliente_nome || null,
    origem: "garcom",
    chave: item.cartItemId != null ? String(item.cartItemId) : null,
  });

  return {
    // `donos`: dono de cada produto já enviado (a comanda mostra quem pediu)
    ligado, pessoas, donos, marcar, mesmoDono, escolher, carimbar, noPedido,
    novaPara, pedirNova: setNovaPara, fecharNova: () => setNovaPara(null), criarPessoa,
  };
}
